const MIN_SPINNING_DURATION = 5
const MAX_SPINNING_DURATION = 1200
const DEFAULT_SPINNING_DURATION = 10
const DEFAULT_SPINS = 7

export default {
  MIN_SPINNING_DURATION,
  MAX_SPINNING_DURATION,
  DEFAULT_SPINNING_DURATION,
  DEFAULT_SPINS,
}
